<div class="table-responsive">
  <table class="table table-hover table-sortable">
    <thead class="thead-light">
      <tr>
        <th class="col-firstName is-sortable" translate="DataList.Columns.FirstName"
          [ngClass]="getSortClasses(sortCols.FIRSTNAME)" (click)="setSort(sortCols.FIRSTNAME)">
        </th>
        <th class="col-lastName is-sortable" translate="DataList.Columns.LastName"
          [ngClass]="getSortClasses(sortCols.LASTNAME)" (click)="setSort(sortCols.LASTNAME)">
        </th>
        <th class="col-userName is-sortable" translate="DataList.Columns.UserName"
          [ngClass]="getSortClasses(sortCols.USERNAME)" (click)="setSort(sortCols.USERNAME)">
        </th>
        <th class="col-userStatus " translate="DataList.Columns.UserStatus">
        </th>
        <th class="col-lastConnection is-sortable" translate="DataList.Columns.LastConnection"
          [ngClass]="getSortClasses(sortCols.LASTCONNECTION)" (click)="setSort(sortCols.LASTCONNECTION)">
        </th>
      </tr>
    </thead>
    <tbody>
      @for (item of list.items; track item.userId) {
        <tr>
          <td class="col-firstName">
            {{ item.firstName ? item.firstName : '-'}}
          </td>
          <td class="col-lastName">{{ item.lastName ? item.lastName : '-'}}</td>
          <td class="col-userName">{{item.userName ? item.userName : '-'}}</td>
          <td class="col-userStatus">
            <span>
              {{ ('DataList.Columns.' + item.userStatus) | translate }}
              @if (item.userStatus === userStatus.Active && !item.isCurrentUser) {
                <i class="far fa-stop-circle"
                  (click)="changeUserStatus(item.userId, userStatus.Inactive)"
                ngbTooltip="{{ 'DataList.Tooltips.Stop' | translate}}"></i>
              }
              @if (item.userStatus === userStatus.Inactive && !item.isCurrentUser) {
                <i class="far fa-play-circle"
                  (click)="changeUserStatus(item.userId, userStatus.Active)"
                ngbTooltip="{{ 'DataList.Tooltips.Start' | translate}}"></i>
              }
              @if (item.userStatus === userStatus.RegistrationRequestSent && !item.isCurrentUser) {
                <i class="far fa-redo-alt"
                  (click)="resendRegistrationRequest(item.userId)"
                ngbTooltip="{{ 'DataList.Tooltips.Resend' | translate}}"></i>
              }
            </span>
          </td>
          <td class="col-lastConnection">
            {{ (item.lastConnection | dateFormat: 'WithHours2') || '-' }}
          </td>
        </tr>
      }
      @if (list.items.length === 0) {
        <tr table-row-empty></tr>
      }
    </tbody>
  </table>
</div>
